import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OrderFinalizeRequestBody, OrderFinalizeResponse } from "./types";

export class OrderFinalizeAPI extends BaseAPI<
  OrderFinalizeRequestBody,
  OrderFinalizeResponse
> {
  protected route = ApiRoutes.order.finalize;
  protected method = RequestMethod.POST;
}
